// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"2d48aca7","977":"8f3f16d7"}[chunkId] + ".chunk.js";
};